import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useStatusFilter } from './useStatusFilter';

export const StatusFilter = ({ value, setFilters, statusOptions }) => {
  const { formSchema, onSubmit } = useStatusFilter({ setFilters });
  const selectedOption = statusOptions.find((i) => i.value === value) ?? statusOptions[0];

  return (
    <Formik
      initialValues={{ status: selectedOption || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="status"
          placeholder="Status"
          size="small"
          component={FormSelect}
          options={statusOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

StatusFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  statusOptions: PropTypes.array.isRequired,
};

StatusFilter.defaultProps = {
  value: '',
};
